/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import React from 'react';
import classNames from 'classnames';
import { useLocaleReceiver } from '../../locale/LocalReceiver.js';
import { Button } from '../../button/index.js';
import useConfig from '../../hooks/useConfig.js';
import '../../_chunks/dep-2acfafca.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../config-provider/ConfigContext.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../button/Button.js';
import '../../_chunks/dep-92728dc5.js';
import '../../hooks/useDomRefCallback.js';
import '../../_util/useRipple.js';
import '../../_util/useAnimation.js';
import '../../_util/setStyle.js';
import '../../_util/dom.js';
import 'raf';
import '../../_chunks/dep-6c5254c6.js';
import '../../_util/easing.js';
import '../../loading/index.js';
import '../../loading/Loading.js';
import '../../common/Portal.js';
import 'react-dom';
import '../../loading/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '../../_chunks/dep-fd3498b6.js';
import '../../_chunks/dep-ec16db36.js';
import '../../_chunks/dep-036ad2cc.js';
import '../../_chunks/dep-0e15088f.js';
import '../../loading/defaultProps.js';
import '../../loading/plugin.js';
import '../../_util/react-render.js';
import '../../_chunks/dep-e0370ebe.js';
import '../../loading/style/css.js';
import '../../loading/type.js';
import '../../button/defaultProps.js';
import '../../_util/parseTNode.js';
import '../../button/style/css.js';
import '../../button/type.js';

var DatePickerFooter = function DatePickerFooter(props) {
  var _useLocaleReceiver = useLocaleReceiver("datePicker"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    local = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  var confirmText = t(local.confirm);
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var enableTimePicker = props.enableTimePicker,
    onConfirmClick = props.onConfirmClick,
    _props$presetsPlaceme = props.presetsPlacement,
    presetsPlacement = _props$presetsPlaceme === void 0 ? "bottom" : _props$presetsPlaceme,
    presets = props.presets,
    onPresetClick = props.onPresetClick,
    selectedValue = props.selectedValue;
  var footerClass = classNames("".concat(classPrefix, "-date-picker__footer"), "".concat(classPrefix, "-date-picker__footer--").concat(presetsPlacement));
  return /* @__PURE__ */React.createElement("div", {
    className: footerClass
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(classPrefix, "-date-picker__presets")
  }, presets && Object.keys(presets).map(function (key) {
    return /* @__PURE__ */React.createElement(Button, {
      key: key,
      size: "small",
      variant: "text",
      onClick: function onClick(e) {
        return onPresetClick(presets[key], {
          e: e,
          preset: _defineProperty({}, key, presets[key])
        });
      }
    }, key);
  })), enableTimePicker && /* @__PURE__ */React.createElement(Button, {
    disabled: !selectedValue,
    size: "small",
    theme: "primary",
    onClick: function onClick(e) {
      return onConfirmClick({
        e: e
      });
    }
  }, confirmText));
};
DatePickerFooter.displayName = "DatePickerFooter";

export { DatePickerFooter as default };
//# sourceMappingURL=Footer.js.map
